import { Building2, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCondominios } from '@/features/condominios/api';
import { Skeleton } from '@/components/ui/skeleton';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';

export function CondominiosListRoute() {
  const { data, isLoading } = useCondominios();
  const items = data?.items ?? [];
  return (
    <PageContainer>
      <PageHeader
        eyebrow="Panel super admin"
        title="Condominios"
        subtitle="Listado de tenants de la plataforma."
        action={
          <Button asChild>
            <Link to="/app/platform/condominios/nuevo">
              <Plus className="mr-2 h-4 w-4" /> Nuevo condominio
            </Link>
          </Button>
        }
      />

      {isLoading ? (
        <Skeleton className="h-40" />
      ) : (
        <ul className="grid gap-3 sm:grid-cols-2">
          {items.map((c) => (
            <li key={c.id}>
              <Link
                to={`/app/condominios/${c.id}`}
                className="block relative overflow-hidden rounded-md border border-[var(--color-hairline)] bg-[var(--color-paper)] p-6 transition-colors hover:border-[var(--color-primary)]"
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="grid h-10 w-10 place-items-center rounded-sm bg-[var(--color-primary-50)] text-[var(--color-primary)]">
                    <Building2 className="h-5 w-5" />
                  </div>
                  <Badge variant="primary">{c.moneda}</Badge>
                </div>
                <h2 className="font-display mt-4 text-xl font-semibold">{c.nombre}</h2>
                <p className="mt-1 text-xs text-[var(--color-ink-muted)]">
                  {c.direccion.calle} {c.direccion.numero}, {c.direccion.comuna}
                </p>
                <p className="mt-2 font-mono text-[0.6875rem] text-[var(--color-ink-faint)]">
                  {c.rut}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </PageContainer>
  );
}
